import baseFeatureFlags from '@/features/feature-flags/constants/base-feature-flags';
import type { BaseFeatureFlags } from '@/features/feature-flags/types/base-feature-flags';
import { merge } from 'lodash-es';
import type { PartialDeep } from 'type-fest';
import { create } from 'zustand';

interface RuntimeFeatureFlagsStore {
  featureFlags: BaseFeatureFlags;
  setFeatureFlags: (overrides?: PartialDeep<BaseFeatureFlags>) => void;
}

const useRuntimeFeatureFlagsStore = create<RuntimeFeatureFlagsStore>((set) => ({
  featureFlags: baseFeatureFlags,
  setFeatureFlags: (overrides) => {
    set({
      featureFlags: merge({}, baseFeatureFlags, overrides ?? {}),
    });
  },
}));

export default useRuntimeFeatureFlagsStore;
